import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../Shared/Utils/UrlConstants';
import { store } from '../../../../Redux/Store';
import { setOrders } from '../../../../Shared/Slice/OrdersSlice';

const Service = {
  getAcces: (data) => {
    return axiosInstance.get(ApiUrlConstant.getAccess(data), { loaderKey: false });
  },
  getOrderList: (id, headers = {}) => {
    return axiosInstance
      .get(ApiUrlConstant.getOrderList(id), {
        headers,
        loaderKey: 'get-orderList',
      })
      .then((res) => {
        try {
          const orders = res?.data || [];
          store.dispatch(setOrders({ id, orders }));
        } catch (e) {
          console.log(e);
        }
        return res;
      });
  },
  startMedicationWithVoucher: () => {
    return axiosInstance.post(
      ApiUrlConstant.startMedicationWithVoucher(),
      {},
      {
        loaderKey: 'start-medication-voucher',
      }
    );
  },
  createPaymentIntent: (data) => {
    return axiosInstance.post(ApiUrlConstant.createPaymentIntent(), data, {
      loaderKey: 'create-payment-intent',
    });
  },
  checkMedicationFormStatus: () => {
    return axiosInstance.get(ApiUrlConstant.checkMedicationFormStatus(), {
      loaderKey: 'check-medication-status',
    });
  },
  getMedicationStatus: () => {
    return axiosInstance.get(ApiUrlConstant.getMedicationStatus(), {
      loaderKey: 'get-medication-status',
    });
  },
  getPatientOffering: () => {
    return axiosInstance.get(ApiUrlConstant.getPatientOffering(), {
      loaderKey: 'get-patient-offering',
    });
  },
};

export default Service;
